import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccessService } from '../services/access.service';

@Injectable()
export class UserContextInterceptor implements HttpInterceptor {
  private accessService = inject(AccessService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.accessService.usernameContext && !req.headers.has('User-Context')) {
      req = req.clone({
        headers: req.headers.append('User-Context', this.accessService.usernameContext)
      });
    }
    return next.handle(req);
  }
}
